import { render, staticRenderFns } from "./SubmitButtonsSection.vue?vue&type=template&id=2d7fb5aa&scoped=true&"
import script from "./SubmitButtonsSection.vue?vue&type=script&lang=js&"
export * from "./SubmitButtonsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7fb5aa",
  null
  
)

export default component.exports